import React from 'react';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

import { ModalContainer } from 'components/Modals/ModalContainer';
import { LoginForm } from 'components/Forms/LoginForm/LoginForm';
import { LOGIN_MODAL_DATA } from 'shared/constants/modal-constants';
import { closeCurrentModal } from 'redux/slices/modals/modals.slice';
import { useAppDispatch, useAppSelector } from 'redux/hooks/reduxHooks';
import { selectCurrentModal } from 'redux/selectors/selectors';
import { EModalsNames } from 'shared/types/modal.interface';

export const LoginModal: React.FC = () => {
  const dispatch = useAppDispatch();
  const currentModal = useAppSelector(selectCurrentModal);

  if (currentModal.entityName !== EModalsNames.LoginModal) return null;

  return (
    <ModalContainer
      onClose={() => dispatch(closeCurrentModal())}
      isOpen={currentModal.entityName === EModalsNames.LoginModal}
    >
      <Stack alignItems="stretch" width="100%">
        {currentModal.data.title && (
          <Typography
            variant="h2"
            sx={{ color: 'primary.main', maxWidth: '90%', alignSelf: 'center' }}
          >
            {currentModal.data.title}
          </Typography>
        )}
        <Typography
          variant="subtitle1"
          color="primary.main"
          sx={{ p: '8px 0 45px', alignSelf: 'center' }}
        >
          {LOGIN_MODAL_DATA.subtitle}
        </Typography>
        <LoginForm />
      </Stack>
    </ModalContainer>
  );
};
